import { apiCall } from 'src/utils/ApiCall';

// Temporary interfaces until TypeScript client is updated
export interface UserExportRecord {
  uuid?: string;
  exportName?: string;
  status?: string;
  exportType?: string;
  createdAt?: string;
  s3Location?: string;
}

export interface ListExportsOutput {
  exports: UserExportRecord[];
}

export const getOpenPOExports = async (): Promise<ListExportsOutput> => {
  const response = await apiCall({
    endpoint: '/ListExports',
    method: 'GET',
  });

  return response as ListExportsOutput;
};
